import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Comunicado from 'Interface/Comunicados';
import { useRemoverComunicadoMutation } from 'View/Service/Default/Comunicados';

interface Props {
  dados: Comunicado;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerComunicado] = useRemoverComunicadoMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerComunicado(dados).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <div className="fs-4">
        <Link
          to={`/comunicados/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.assunto}
          <small className="d-block fs-6 text-muted">
            {dados.mensagem.cortar(50)}
          </small>
        </Link>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end">
        <div className="ms-5 fs-5 text-end">
          {dados.usuario?.nome}
          <small className="d-block fs-6 text-muted">Por</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          {dados.criado.data().toLocaleString()}
          <small className="d-block fs-6 text-muted">Criado em</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          <Botao
            icone="trash"
            tema="danger"
            className="ms-2"
            confirmacao="Você tem certeza que deseja remover esse comunicado? Essa ação é irreversivel."
            onClick={remover}
          />
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
